import { useTRPC } from '@/utils/trpc';
import { QueryStateHandler } from '@liza/ui/components/QueryStateHandler';
import { ConditionDetail } from '@liza/ui/components/records';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
};

export const Condition = ({ id }: Props): React.ReactElement => {
  const { t } = useTranslation('records');
  const trpc = useTRPC();

  const conditionQuery = useQuery(trpc.patient.condition.get.queryOptions({ id }));

  return (
    <QueryStateHandler query={conditionQuery} emptyMessage={t('noConditionsFound')}>
      {(data) => <ConditionDetail condition={data.condition} />}
    </QueryStateHandler>
  );
};
